module.exports = __webpack_public_path__ + "img/prove3.9fecc787.png";